// @format

import {showNotice} from './notice';
import 'jquery';
import 'summernote';
import {proceedSuccessNotice} from './notifier';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light-border.css';
import 'tippy.js/animations/scale.css';
import {subscribeLinkedinMessages} from "./channels/linkedin_messages_channel"
// import {refreshGridData} from "./grid"
import {initTwilioDevice, makeCall, hangupCall, muteCall, isCallMuted} from "./twilio_voice"
import type {Call} from "@twilio/voice-sdk"
import {setStatusCallingOverride} from './utils/bots_prospects/status_calling_overrides'
import { announceFollowUps } from "./phone_dashboard/follow_ups";
import {
  callModal,
  recordingPlayer,
  computerMode,
  phoneMode,
  callEnded,
  callEndedRecording,
  callEndedPlayer,
  recordingProcessing,
  recordingUnavailable
} from './templates/components/calling'
import { getHTMLElement, getHTMLString } from './templates/template_importer'
import { syncPageScrollLock } from "./qlfr_modal";
import { initCallEndScreen, closeOutcomeMenu, drawWaveform, paintWaveform } from './call_end_screen'

export function initProspectToggle(): void {
  $(document).on('change', '.bots-prospect-toggle', e => {
    const t = $(e.currentTarget);

    $.ajax({
      url: '/bots/' + t.data('bot-id') + '/prospects/' + t.data('id'),
      contentType: 'application/json; charset=UT-8',
      dataType: 'json',
      data: JSON.stringify({
        authenticity_token: $('[name="csrf-token"]').attr('content'),
        unreviewed: t.hasClass("reviewed"),
        bots_prospect: {
          rejected_at: !t.prop('checked') && new Date()
        },
      }),
      error: function(jqXHR, exception) {
        t.prop('checked', !t.prop('checked'));
      },
      success: (response) => {
        const $popover = t.closest('tr').find('.reject-reasons-popover');
        const $contactCandidateBtn = t.closest('tr').find('.contact-candidate-btn');
        if (t.prop('checked')) {
          $popover.addClass('hide');
          $contactCandidateBtn.prop('disabled', false)
        } else {
          $popover.removeClass('hide');
          $contactCandidateBtn.prop('disabled', true)
        }

        if($("#companies-group").data("tab") == "rejected") {;
          handleProspect(t, response);
          updateCompanyBlockCounts(t.closest('.company-block'), response);
        } else {
          handleCompanyGroup(t, response, true);
        }
      },
      type: 'PATCH',
    });
  });

  $(document).on('click', e => {
    if (!$(e.target).closest('.reject-reasons-popover, .bots-prospect-toggle').length) {
      $('.reject-reasons-popover').addClass('hide');
    }
  });
}

export const notifyCandidateRowsLoaded = (): void => {
  document.dispatchEvent(new CustomEvent('candidates:rows-loaded'));
}

const handleCompanyGroup = (t, response, triggeredOnProspect) => {
  const $companyBlock = t.closest('.company-block');
  updateCompanyBlockData($companyBlock, response);

  if(triggeredOnProspect) {
    handleProspect(t, response)
  } else {
    $companyBlock.find('.render-grouped-prospects').html(response['partial'])
    notifyCandidateRowsLoaded();
  }
}

export const updateCompanyBlockData = ($companyBlock, response) => {
  const $companyProcessedNote = $companyBlock.find('.company-processed-note');
  const $companyName = $companyBlock.find('.company-name');
  const $rejectAllBtn = $companyBlock.find('.reject-all-btn');

  updateCompanyBlockCounts($companyBlock, response);

  if(response['pending_count'] == 0  && response['company_processed_note']) {
    $rejectAllBtn.addClass('d-none')
    $rejectAllBtn.prop('disabled', true)
    $companyProcessedNote.text(response['company_processed_note'])
    $companyName.addClass('processed')
  } else {
    $rejectAllBtn.removeClass('d-none')
    $rejectAllBtn.prop('disabled', false)
    $companyProcessedNote.text('')
    $companyName.removeClass('processed')
  }
}

export const updateCompanyBlockCounts = ($companyBlock, response) => {
  $companyBlock.find('.total-count').text(response['candidate_count'])
  $companyBlock.find('.accepted-contacted-count').text(response['accepted_contacted_count'])
  $companyBlock.find('.rejected-count').text(response['rejected_count'])
  $companyBlock.find('.pending-count').text(response['pending_count'])
}

const handleProspect = (t, response) => {
  const $prospect = t.closest('tr').find('.prospect');
  const $candidateProcessedNote = t.closest('tr').find('.candidate-processed-note');

  if(t.prop('checked')) {
    $prospect.removeClass('processed')
    $candidateProcessedNote.text('')
  } else {
    $prospect.addClass('processed')
    $candidateProcessedNote.text(response['candidate_processed_note']);
  }
}

export function initContactCandidateButton(): void {
  $(document).on('ajax:success', '.mark-candidate-accepted-form', function(event) {
    const response = event.detail[0];
    // The row, not the form: emptying the actions cell below detaches the form, and
    // handleCompanyGroup needs an element still in the DOM to reach .company-block.
    const $row = $(this).closest('tr');
    handleCompanyGroup($row, response, true)

    // The row stays in the company block but is no longer actionable: drop its
    // controls and move the outcome into the Status column, matching what
    // bots_prospects/_queued_prospect renders for an already-reviewed candidate.
    $row.find('.bulk-check, .switch, .reject-reasons-popover').remove();
    $row.find('[data-row-actions]').empty();
    $row.find('[data-row-status]').html(
      '<div class="status-tag accepted-tag">Accepted</div>' +
      `<div class="candidate-processed-note">${response['candidate_processed_note'] || ''}</div>`
    );
  });
}

export function initRejectAllCandidatesButton(): void {
  $(document).on('ajax:success', '.reject-all-candidates-form', function(event) {
    handleCompanyGroup($(this), event.detail[0], false)
  });
}

export const initRejectReasonListener = () => {
  $(document).on('click', '.reject-reasons a', e => {
    e.preventDefault();
    const link = $(e.currentTarget);
    const wrapper = link.closest('.reject-reasons-wrap');
    if (link.hasClass('other')) {
      wrapper.find('.reject-reasons').addClass('hidden')
      wrapper.find('.reject-prospect-button').removeClass('hidden')
      wrapper.find('.add-reject-reason-button').removeClass('hidden')
      wrapper.find('.back-link').removeClass('hidden')
      initAddToBlockListener(wrapper);
      initAddRejectReasonListener(wrapper);
      initBackLinkListener(wrapper);
    } else {
      sendRejectReason(`/add_reject_reason/${wrapper.data('id')}?reason=${link.data('reason')}`, link, wrapper);
    }
  });
}

const initAddToBlockListener = (wrapper) => {
  wrapper.find('.reject-prospect-button').off('click').on('click', function (e) {
    e.preventDefault();
    const t = $(this)
    const confirmMessage = 'Are you sure you want to add this company to ignore list?'
    const confirmed = confirm(confirmMessage)
    if (confirmed) {
      sendRejectReason(`/bots/${t.data('bot-id')}/prospects/${t.data('id')}/add_to_company_blocklist`, t, wrapper);
      $(this).text('Company added to ignore list').css('pointer-events', 'none');
      $(this).closest('.reject-reasons-wrap').find('.add-reject-reason-button').addClass('hidden')
      $(this).closest('.reject-reasons-wrap').find('.back-link').addClass('hidden')
    }
  })
}

const initAddRejectReasonListener = (wrapper) => {
  wrapper.find('.add-reject-reason-button').off('click').on('click', function (e) {
    e.preventDefault();
    const link = $(e.currentTarget);
    const rejectReasonInput = prompt('Please enter reject reason', link.data('reason'));

    if (rejectReasonInput || link.data('reason')) {
      sendRejectReason(`/add_reject_reason/${wrapper.data('id')}?reason=${rejectReasonInput}`, link, wrapper);
    }
  })
}

const initBackLinkListener = (wrapper) => {
  wrapper.find('.back-link').off('click').on('click', (e) => {
    e.preventDefault();
    wrapper.find('.reject-reasons').removeClass('hidden')
    wrapper.find('.reject-prospect-button').addClass('hidden')
    wrapper.find('.add-reject-reason-button').addClass('hidden')
    wrapper.find('.back-link').addClass('hidden')
  })
}

const sendRejectReason = (url, link, wrapper) => {
  $.ajax({
    url: url,
    data: {
      authenticity_token: $('[name="csrf-token"]').attr('content'),
    },
    type: 'PATCH',
    success: function(response) {
      link.addClass('checked')
      if (wrapper.hasClass("reject-reasons-wrap")){
        wrapper.html(response.reject_reason)
      }
    },
  });
}

export function initEditProspectListener(): void {
  $(document).on('click', '.edit-bots-prospect', e => {
    const botsProspectId = $(e.currentTarget).data('bots-prospect-id');
    $('.edit-form-' + botsProspectId).toggle('fast');
  });
  $(document).on('click', '.customize-message-button', e => {
    const $btnEle = $(e.currentTarget);
    const botsProspectId = $(e.currentTarget).data('bots-prospect-id');
    const $toggledEle = $('.custom-message-' + botsProspectId)

    if($toggledEle.is(':visible')) {
      $btnEle.removeClass('active');
    } else {
      $btnEle.addClass('active');
    }

    $toggledEle.toggle('fast');
  });

  $(document).on('click', '.delete-customized-message-button', e => {
    const customMessageId = $(e.currentTarget).data('custom-message-id');
    if (confirm('Are you sure?')) {
      fetch('/custom_messages/' + customMessageId + '/delete', {
        method: 'delete',
        credentials: 'same-origin',
        headers: {
          'X-CSRF-TOKEN': document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute('content'),
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then(_ => location.reload());
    }
  });

  $(document).on('click', '.checked-bots-prospect', function(e) {
    e.preventDefault();
    let url = $(e.currentTarget).attr('href');
    const $ele = $(this);

    if (confirm('Are you sure?')) {
      $.ajax({
        url: url,
        data: {
          authenticity_token: $('[name="csrf-token"]').attr('content'),
        },
        type: 'PATCH',
        success: function(res) {
          const checkedBy = res['checked_by']
          const checkedAt = res['checked_at']
          const $panel = $ele.closest('.reply-block')
          if ($panel.length) {
            $panel.find('.reply-review-info')
              .html(`<i class="fas fa-check-circle"></i> Reviewed by ${checkedBy} · ${checkedAt}`)
              .addClass('show')
            $ele.remove()
          } else {
            $ele.replaceWith(`<div><strong>${checkedBy}</strong></div><div>${checkedAt}</div>`)
          }
        },
      });
    }
  });
}

export function initPhoneCompletedListener(): void {
  $(document).on('click', '.phone-completed', e => {
    const target = $(e.currentTarget);
    target.css('display', 'none');
    const botsProspectId = target.data('bots-prospect-id');
    $('.phone-completed-triage-' + botsProspectId).show();
  });
}

export function initEmailsReceived(): void {
  $(document).on('change', '#emails_received', e => {
    const target = $(e.currentTarget);
    window.location.href =
      '/bots/' +
      target.data('botId') +
      '/prospects/phone/?emails_received=' +
      $('#emails_received option:selected').val();
  });
}

export function initReApproachedBtn(): void {
  $(".manually-unblocked").on('click', function () {
    const thisObj = $(this)
    thisObj.closest('td').find('.manually-re-unblocked').removeClass("active")
    thisObj.closest('td').find('.manually-unblocked').addClass("active");
  })
  $(".manually-re-unblocked").on('click', function () {
    const thisObj = $(this)
    thisObj.closest('td').find('.manually-re-unblocked').addClass("active")
    thisObj.closest('td').find('.manually-unblocked').removeClass("active");
  })
}

export function initCheckedBotsProspect(): void {
  $("#check-all-prospects").on("ajax:success", function(event) {
    const target = event.currentTarget;
    const detail = event.detail[0]
    const checkedBy = detail.checked_by
    const checkedAt = detail.checked_at
    $(target).addClass("disabled")
    $(".checked-bots-prospect").replaceWith(`<div class="intro--reviewed-by">Reviewed by <strong>${checkedBy}</strong> at ${checkedAt}</div>`)
  })
}

export function initBotProspectHistory(): void {
  $(".history-button").on("click", function(event) {
    const target = event.currentTarget;
    const botsProspectId = target.dataset.toggleId;
    const $historyElem = $(`#${botsProspectId}`);

    if($historyElem.is(':visible')) {
      $(target).removeClass('active');
    } else {
      $(target).addClass('active');
    }
    // $historyElem.toggle('fast');
  });
}

export function initPersonalizedMessage(): void {
  const sequenceBtn = 'input[name="custom_message[sequence_id]"]'
  $(document).off('click', sequenceBtn).on('click', sequenceBtn, function () {
    const $form = $(this).closest('form');

    $form.find('#custom_message_subject').val($(this).data('subject'));
    $form.find('#custom_message_body').summernote("code", $(this).data('body'));
  })
}

export function initSendConnectionRequestLinkedInModal(): void {
  let currentBotsProspectId: string | null = null
  let currentBotId: string | null = null
  let currentSendUrl: string | null = null
  let currentCheckStatusProfileUrl: string | null = null
  let verifyUrl: string | null = null
  let subscription

  function markConnectionRequestSent(requestId?: string | number): void {
    $('#sendConnectionRequestLinkedInModal').modal('hide')
    if (!currentBotsProspectId) return

    const $button = $(`.view-invitation-form[data-bots-prospect-id="${currentBotsProspectId}"]`)
    if (!$button.length) return

    const pad = (n: number) => String(n).padStart(2, '0')
    const today = new Date()
    const sentDate = `${pad(today.getDate())}-${pad(today.getMonth() + 1)}-${today.getFullYear()}`

    $button.removeClass("view-invitation-form").addClass("unipile-verify-button")
    $button.attr("title", `Connection request sent ${sentDate}`)
    $button.find("i").removeClass("text-success").addClass("text-primary")
    $button.find("i.fa-long-arrow-alt-right").removeClass("hidden")
    if (requestId) {
      $button.attr("data-bots-prospect-unipile-request-id", String(requestId))
    }
  }

  $(document).off('click', '.btn-disabled').on('click', '.btn-disabled', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    return;
  });

  $(document).off('click', '.view-invitation-form').on('click', '.view-invitation-form', function (e) {
    e.preventDefault();
    // e.stopImmediatePropagation();
    const $button = $(this);
    const modal = $('#sendConnectionRequestLinkedInModal')
    $button.addClass("disabled")
    $button.find("i").addClass("fa-spin")

    currentBotsProspectId = $button.data('bots-prospect-id')
    currentBotId = $button.data('bot-id')
    const prospectName = $button.data('prospect-name')
    currentSendUrl = $button.data('send-url')
    currentCheckStatusProfileUrl = $button.data('check-status-profile-url')
    verifyUrl = $button.data('verify-unipile-invitation-request-url')
    $.ajax({
      url: currentCheckStatusProfileUrl,
      method: 'POST',
      success: function(response) {
        if(response.bots_prospect_unipile_request_id) {
          $button.attr("data-bots-prospect-unipile-request-id", response.bots_prospect_unipile_request_id);
        }
        if(response.notice == "Connected"){
          $button.removeClass("view-invitation-form").addClass("retrieve-message-button")
          $button.find("i").removeClass("text-primary").addClass("text-success");
          $button.attr("title", "Candidate already in your network");
        } else if(response.notice == "Invited") {
          $button.removeClass("view-invitation-form").addClass("unipile-verify-button")
          $button.find("i").removeClass("text-success").addClass("text-primary");
          $button.find("i.fa-long-arrow-alt-right").removeClass("hidden")
        } else if (response.notice == "Not invited") {
          modal.find('.initial-content').show()
          modal.find('.note-form-content').hide()
          modal.find('.modal-title').text('Add a note to your invitation?')

          modal.find('.prospect-name-placeholder').text(prospectName)

          modal.find('.write-with-ai-button').attr('data-bot-id', currentBotId)
          modal.find('.write-with-ai-button').attr('data-bots-prospect-id', currentBotsProspectId)

          modal.find('.invitation-note-textarea').val('')
          updateCharacterCount(modal.find('.invitation-note-textarea')[0] as HTMLTextAreaElement)

          modal.modal('show')
        }
      },
      error: function(xhr) {
        const errorMessage = xhr.responseJSON?.alert || "Failed to send connection request"
        if (errorMessage == "Disconnected account"){
          const confirmed = confirm("Your Unipile account has been disconnected. Do you want to log in again?");
          if (confirmed) {
            $.ajax({
              url: '/unipile/clear_unipile_account_id',
              method: 'POST',
              success: function(response) {
                window.location.href = "/profile";
              },
              error: function(xhr) {
                alert("Failed to clear Unipile account ID");
              }
            })
          }
          return
        }
        alert(errorMessage)
        return
      },
      complete: function() {
        $button.removeClass("disabled")
        $button.find("i").removeClass("fa-spin")
      }
    })
  })


  // unipile-verify-button
  $(document).off('click', '.unipile-verify-button').on('click', '.unipile-verify-button', function(e){
    e.preventDefault();

    const $button = $(this);
    $button.addClass("disabled")
    $button.find("i.fa-long-arrow-alt-right").addClass("hidden")
    $button.find("i").addClass("fa-spin")

    currentBotsProspectId = $button.data('bots-prospect-id')
    currentBotId = $button.data('bot-id')
    const prospectName = $button.data('prospect-name')
    currentSendUrl = $button.data('send-url')
    currentCheckStatusProfileUrl = $button.data('check-status-profile-url')
    verifyUrl = $button.data('verify-unipile-invitation-request-url')


    $.ajax({
      url: verifyUrl,
      method: 'POST',
      success: function(response) {
        if(response.notice == "Connected successfully"){
          $button.removeClass("unipile-verify-button").addClass("retrieve-message-button")
          $button.find("i").removeClass("text-primary").addClass("text-success");
          $button.attr("title", "Candidate already in your network");
        } else if(response.notice == "Invitation is still pending") {
          $button.find("i").removeClass("text-success").addClass("text-primary");
          $button.find("i.fa-long-arrow-alt-right").removeClass("hidden")
        }
      },
      error: function(xhr) {
        const errorMessage = xhr.responseJSON?.alert || "Failed to verify connection request"
        if (errorMessage == "Disconnected account"){
          const confirmed = confirm("Your Unipile account has been disconnected. Do you want to log in again?");
          if (confirmed) {
            $.ajax({
              url: '/unipile/clear_unipile_account_id',
              method: 'POST',
              success: function(response) {
                window.location.href = "/profile";
              },
              error: function(xhr) {
                alert("Failed to clear Unipile account ID");
              }
            })
          }
          return
        }
        if (errorMessage == "No matching invitation found in sent invitations"){
          $button.removeClass("unipile-verify-button").addClass("view-invitation-form")
          $button.attr("title", "Send Connection Request LinkedIn");
          $button.find("i").removeClass("text-primary text-success");
          $button.find("i.fa-long-arrow-alt-right").addClass("hidden")
        }
        alert(errorMessage)
        return
      },
      complete: function() {
        $button.removeClass("disabled")
        $button.find("i").removeClass("fa-spin")
      }
    })
  })

  $(document).off('click', '.retrieve-message-button').on('click', '.retrieve-message-button', function(e){
    e.preventDefault();
    const $button = $(this);
    const botsProspectId = $button.data('bots-prospect-id');
    const sendUrl = $button.data('send-url');
    const originalTitle = $button.attr("title");
    const botsProspectUnipileRequestId = $button.data('bots-prospect-unipile-request-id');

    if ($button[0]._tippy) {
      $button[0]._tippy.show();
      $button.removeAttr('title');
      return;
    }

    tippy($button[0], {
      content: `
        <div style="text-align:center; min-width: 180px; margin: 10px 5px">
          <div style="margin-bottom: 8px; font-weight: 600; font-size: 16px">Retrieve message history?</div>
          <div style="display:flex; justify-content: center; gap: 8px;">
            <button class="btn custom-btn white-btn cancel-btn">Cancel</button>
            <button class="btn custom-btn blue-btn confirm-btn" data-bots-prospect-id="${botsProspectId}">Yes, retrieve</button>
          </div>
        </div>
      `,
      allowHTML: true,
      theme: 'light-border',
      interactive: true,
      trigger: 'manual',
      placement: 'right',
      animation: 'scale',
      onShow(instance) {
        const popover = instance.popper;

        $button.removeAttr('title');

        $(popover).find('.cancel-btn').on('click', () => {
          instance.hide();
        });

        $(popover).find('.confirm-btn').one('click', function() {
          const botsProspectId = $button.data('bots-prospect-id');
          const prospectName = $button.data('prospect-name')
          const prospectPosition = $button.data('prospect-position')
          const modalMessageHistory = $('#messageHistoryModal')
          modalMessageHistory.data('botsProspectUnipileRequestId', botsProspectUnipileRequestId);
          modalMessageHistory.data('prospectName', prospectName);
          modalMessageHistory.data('botsProspectId', botsProspectId);
          modalMessageHistory.find('.name').text(prospectName);
          modalMessageHistory.find('.position').text(prospectPosition);

          const words = prospectName.trim().split(' ');
          let initials = '';
          if (words.length === 1) {
            initials = words[0].substring(0, 2).toUpperCase();
          } else {
            initials = (words[0][0] + words[words.length - 1][0]).toUpperCase();
          }
          modalMessageHistory.find('.avatar').text(initials);
          $.ajax({
            url: "/linkedin_message_histories/create_or_find",
            method: 'POST',
            data: {
              bots_prospect_id: botsProspectId,
              bots_prospect_unipile_request_id: botsProspectUnipileRequestId
            },
            success: function(response) {
              modalMessageHistory.data('linkedin_chat_id', response.id);
            },
            error: function(xhr) {
              const errorMessage = xhr.responseJSON?.alert || ""
              if (errorMessage == "No chat messages were found"){
                modalMessageHistory.data('linkedin_chat_id', null);
              }
            },
            complete: function() {
              const container = $('#messages-container');
              container.empty();
              modalMessageHistory.modal('show');
              instance.hide();
            }
          })
        });

        // Hidden when button out of viewport
        const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
              instance.hide();
            }
          });
        }, { threshold: 0.1 });

        observer.observe($button[0]);
        (instance as any)._observer = observer;
      },
      onHide(instance) {
        $button.attr('title', originalTitle);
        if ((instance as any)._observer) {
          (instance as any)._observer.disconnect();
          (instance as any)._observer = null;
        }
      }
    });
    $button[0]._tippy.show();
  })

  $(document).on('hidden.bs.modal', '#messageHistoryModal', function(e) {
    if (subscription) {
      subscription.unsubscribe();
      subscription = null;
    }
      const $input = $(this).find('#message-input')
      $input.val("")
  });

  $(document).off('shown.bs.modal', '#messageHistoryModal').on('shown.bs.modal', '#messageHistoryModal', function(e) {
    const modal = $(this);
    const linkedin_chat_id = modal.data('linkedin_chat_id');
    const prospectName = modal.data('prospectName');
    const botsProspectId = modal.data('botsProspectId');
    const container = $('#messages-container');
    const $input = modal.find('#message-input')
    container.empty();
    subscription = subscribeLinkedinMessages(linkedin_chat_id, (msg) => {
      appendNewMessage(msg, prospectName)
    })

    if (linkedin_chat_id == null) {
      container.append(`
        <div class="text-center text-muted small mt-2" data-messages-target="message">
          No chat messages available yet. Start the conversation to see messages here.
        </div>
      `);
    }else{
      $.ajax({
        url: "/linkedin_message_histories/find_message_histories",
        method: 'POST',
        data: {
          linkedin_chat_id: linkedin_chat_id
        },
        success: function(response) {
          response.recent_messages.forEach(msg => {
            const html = renderMessage(msg, prospectName);
            container.append(html);
          });
          container.scrollTop(container[0].scrollHeight);
        },
        error: function(xhr) {
          const errorMessage = xhr.responseJSON?.alert || ""
          alert(errorMessage)
        },
        complete: function() {
          $('#chat-spinner').removeClass('d-flex').hide();
          $input?.trigger('focus')
        }
      })
    }
  })

  $(document).off('click', '.send-message-btn').on('click', '.send-message-btn', function(e) {
    e.preventDefault()
    const $form = $(this).closest('form')
    const $input = $form.find('#message-input')
    const $button = $(this)
    const modal = $('#messageHistoryModal')
    const botsProspectUnipileRequestId = modal.data('botsProspectUnipileRequestId')
    const message = $input.val()?.toString().trim()
    if (!message) return
    $input.prop("disabled", true)
    $button.prop("disabled", true)
    $button.val("Sending...")

    $.ajax({
      url: "/linkedin_message_histories/send_message",
      method: 'POST',
      data: {
        bots_prospect_unipile_request_id: botsProspectUnipileRequestId,
        text: message
      },
      success: function(response) {
        appendNewMessage(response.send_message)
      },
      error: function(xhr) {
        const el = document.getElementById("chat-error");
        if (!el) return;
        el.classList.remove("d-none");
        setTimeout(() => {
          el.classList.add("d-none");
        }, 3000);
      },
      complete: function() {
        $input.val("")
        $input.prop('disabled', false)
        $input?.trigger('focus')
        $button.prop('disabled', false)
        $button.val("Send Message")
      }
    })
  })

  $(document).on('keydown', '#message-input', function(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault()
      $(this).closest('form').find('.send-message-btn').trigger('click')
    }
  })

  // Handle the "Add a note" button click
  $(document).on('click', '.add-note-button', function() {
    const modal = $('#sendConnectionRequestLinkedInModal')
    if (!currentSendUrl) return
    modal.find('.invitation-form').attr('action', currentSendUrl)
    modal.find('.initial-content').hide()
    modal.find('.note-form-content').show()
    modal.find('.modal-title').text('Add a note to your invitation')
    modal.find('.invitation-note-textarea').focus()
  });

  document.addEventListener("turbo:before-cache", () => {
    const modal = $('#sendConnectionRequestLinkedInModal')
    modal.hide()
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
  })

  // Handle the "Send without note" button click
  $(document).on('click', '.send-without-note-button', function() {
    if ($(this).hasClass('sending')) { return false }
    if (!currentSendUrl) return

    const $button = $(this)
    const originalText = $button.text()
    $button.addClass('sending')
      .prop('disabled', true)
      .html(`<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Sending...`)

    $.ajax({
      url: currentSendUrl,
      method: 'POST',
      data: {
        authenticity_token: $('[name="csrf-token"]').attr('content')
      },
      success: function(response) {
        markConnectionRequestSent(response?.bots_prospect_unipile_request_id)
      },
      error: function(xhr) {
        const errorMessage = xhr.responseJSON?.alert || "Failed to send connection request"
        alert(errorMessage)
        $('#sendConnectionRequestLinkedInModal').modal('hide')
      },
      complete: function() {
        $button.removeClass('sending')
          .prop('disabled', false)
          .text(originalText)
      }
    })
    return false
  })

  // Cancel sends with a note form
  $(document).on('click', '.cancel-note-button', function() {
    const modal = $('#sendConnectionRequestLinkedInModal')
    modal.find('.note-form-content').hide()
    modal.find('.initial-content').show()
    modal.find('.modal-title').text('Add a note to your invitation?')
    modal.find('.invitation-note-textarea').val('')
    updateCharacterCount(modal.find('.invitation-note-textarea')[0] as HTMLTextAreaElement)
  })

  // Character counter for textarea
  $(document).on('input', '.invitation-note-textarea', function() {
    updateCharacterCount(this)

    const modal = $('#sendConnectionRequestLinkedInModal')
    const submitButton = modal.find('input[type="submit"]')

    const value = $(this).val()
    const hasContent = typeof value === 'string' && value.trim().length > 0

    submitButton.prop('disabled', !hasContent)
  })

  // Handle the "Send with note" button click
  $(document).on("ajax:beforeSend", ".invitation-form", function() {
    const form = $(this)
    form.find('input[type="submit"]').addClass('d-none')
    form.find('.spinner-border').removeClass('d-none')
  })

  $(document).on("ajax:complete", ".invitation-form", function() {
    const form = $(this)
    form.find('input[type="submit"]').removeClass('d-none').prop('disabled', false)
    form.find('.spinner-border').addClass('d-none')
  })

  $(document).on('ajax:success', '.invitation-form', function(event) {
    const response = event.detail[0]
    markConnectionRequestSent(response?.bots_prospect_unipile_request_id)
  })

  $(document).on('ajax:error', '.invitation-form', function(event) {
    const data = event.detail[0]
    const errorMessage = data?.alert || "Failed to send connection request"

    if (errorMessage == "Disconnected account"){
      const confirmed = confirm("Your Unipile account has been disconnected. Do you want to log in again?");
      if (confirmed) {
        $.ajax({
          url: '/unipile/clear_unipile_account_id',
          method: 'POST',
          success: function(response) {
            window.location.href = "/profile";
          },
          error: function(xhr) {
            alert("Failed to clear Unipile account ID");
          }
        })
      }
      return
    }
    alert(errorMessage)
  })
}

function updateCharacterCount(textarea: HTMLTextAreaElement): void {
  const currentLength = textarea.value.length
  const maxLength = 300
  const counter = $(textarea).closest('.note-form-content').find('.current-count')

  counter.text(currentLength);

  if (currentLength > maxLength * 0.9) {
    counter.addClass('text-warning')
  } else {
    counter.removeClass('text-warning')
  }

  if (currentLength >= maxLength) {
    counter.addClass('text-danger').removeClass('text-warning')
  } else {
    counter.removeClass('text-danger')
  }
}

$(document).on("ajax:success", ".unipile-connect-button", function(event) {
  console.log("EEE", event);
  const data = event.detail[0];
  $(this).addClass("success").attr("disabled", "disabled");
  $(this).find("i").removeClass("fa-spin").addClass("text-primary");
  $(this).find("i.fa-long-arrow-alt-right").removeClass("hidden");
  $(this).attr("title", "Connection Request Sent " + new Date().toLocaleDateString("en-GB").replace(/\//g, "-"));
});

$(document).on("ajax:error", ".unipile-connect-button", function(event) {
  console.log("EEE", event);
  const data = event.detail[0];
  const errorMessage = data?.alert || "Failed to send connection request";
  $(this).removeClass("disabled");
  $(this).find("i").removeClass("fa-spin text-success");
  if (errorMessage == "Disconnected account"){
    const confirmed = confirm("Your Unipile account has been disconnected. Do you want to log in again?");
    if (confirmed) {
      $.ajax({
        url: '/unipile/clear_unipile_account_id',
        method: 'POST',
        success: function(response) {
          window.location.href = "/profile";
        },
        error: function(xhr) {
          alert("Failed to clear Unipile account ID");
        }
      })
    }
    return
  }
  alert(errorMessage);
});

$(document).on("ajax:beforeSend", ".unipile-connect-button", function() {
  $(this).addClass("disabled");
  $(this).find("i").addClass("fa-spin");
});

// POST /prospects/:id/fetch_phone — looks the number up when none is on file.
// Pass bots_prospect_id to also get the profile card's re-rendered phone row.
export function fetchPhoneNumber(prospectId: string, data: Record<string, string> = {}): JQuery.jqXHR {
  return $.ajax({ url: `/prospects/${prospectId}/fetch_phone`, type: 'POST', data });
}

export function initFetchPhoneButton(): void {
  $(document).off('click', '.fetch-phone-btn').on('click', '.fetch-phone-btn', e => {
    e.stopPropagation();
    const $target = $(e.currentTarget);
    const id = $target.data('prospect-id')
    const botsProspectId = $target.data('bots-prospect-id')
    const $pop = $target.closest('.popover');
    const popId = $pop.attr('id');
    const $trigger = $('[aria-describedby="' + popId + '"]');
    const $spinner = $('<div class="ml-auto"><i class="fas fa-spinner fa-spin"></i> Fetching...</div>');
    const $phoneBtn = $('.phone-button-' + botsProspectId);
    const $replaceTarget = $target.closest('.no-phone-number').length ? $target.closest('.no-phone-number') : $target;

    $replaceTarget.replaceWith($spinner);

    fetchPhoneNumber(id).then(
      function(data) {
        if(data.status == 'found') {
          if ($target.hasClass('phone-number-sync-btn')) {
            $spinner.replaceWith($target);
            $(".call-modal-phone-number").text(data.phone_number)
            $("#call-modal").attr('data-phone-number', data.phone_number)
          }

          $phoneBtn
            .attr('data-phone-number', data.phone_number)
            .removeAttr('data-toggle')
            .removeAttr('data-placement')
            .removeAttr('data-content')
            .removeAttr('data-html')
            .removeAttr('trigger')
            .popover('dispose');
        } else if (data.status == 'not_found') {
          const content = "<div class='close-popover'><i class='far fa-times'></i></div>" +
            `<div class="no-phone-number d-flex align-items-center">
              ${data.phone_number}
              <button class="btn fetch-phone-btn btn-refetch" data-prospect-id="${id}" data-bots-prospect-id="${botsProspectId}">
                <img src="/refresh.svg" alt="refresh" class="refresh-icon">
              </button>
            </div>`;
          $trigger.attr('data-content', content);
          $spinner.replaceWith(content);
        }

        $trigger.removeClass('found not-found').addClass(data.status === 'found' ? 'found' : 'not-found');
      },
      function() {
        alert('Failed to fetch phone number');
        $spinner.replaceWith($target);
      }
    );
  });

  $(document).on("click", ".close-popover", function(e) {
    $(e.target).closest('.popover').popover("hide");
  });

  $(document).on('click', function (e) {
    if (
      !$(e.target).closest('.popover').length &&
      !$(e.target).closest('[data-toggle="popover"]').length
    ) {
      $('[data-toggle="popover"]').popover('hide');
    }
  });

  function isElementVisibleInWrapper(el, wrapper) {
    const elRect = el.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();

    const headerHeight = $('.gridjs-thead').outerHeight() || 0;

    return (
      elRect.top > wrapperRect.top + headerHeight &&
      elRect.bottom < wrapperRect.bottom &&
      elRect.left > wrapperRect.left &&
      elRect.right < wrapperRect.right
    );
  }

  function hidePopoverIfButtonHidden() {
    const wrapper = document.querySelector('.gridjs-wrapper');
    if (!wrapper) return;

    $('[data-toggle="popover"]').each(function () {
      const button = this;
      const popoverVisible = $(button).attr('aria-describedby');
      if (popoverVisible && !isElementVisibleInWrapper(button, wrapper)) {
        $(button).popover('hide');
      }
    });
  }

  const $wrapper = $('.gridjs-wrapper');
  $wrapper.on('scroll', hidePopoverIfButtonHidden);
  $(window).on('scroll', hidePopoverIfButtonHidden);
}

export function initStatusCallingDropdown(): void {
  $(document).on("change", ".status_calling", function() {
    const $selectEle = $(this);
    const botsProspectId = $selectEle.data('bots-prospect-id');
    const statusCalling = $selectEle.val();

    $.ajax({
      url: `/bots_prospects/${botsProspectId}/update_status_calling`,
      type: 'PUT',
      data: {
        bots_prospect: {
          status_calling: statusCalling
        }
      },
      success: function(data) {
        $selectEle.removeClass().addClass(String(`form-control status_calling ${statusCalling}`));
        setStatusCallingOverride(String(botsProspectId), String(statusCalling));
        proceedSuccessNotice(data);
        announceFollowUps(String(botsProspectId), data.follow_ups);
      }
    });
  });
}

// BotsProspect::STATUS_CALLING_LABELS — the stored call outcomes under their Phone Dashboard names.
const CALL_OUTCOME_LABELS: Record<string, string> = {
  interview_booked: 'Interview booked',
  follow_up_later: 'Call back later',
  maybe_later: 'Maybe later',
  no_response: 'No answer',
  not_interested: 'Not interested',
  hired: 'Hired',
  disqualified: 'Disqualified',
  wrong_person: 'Wrong person',
};

const CALL_STATUS_LABELS: Record<string, string> = {
  initiated: 'Initiated',
  ringing: 'Ringing',
  in_progress: 'In progress',
  busy: 'Busy',
  no_answer: 'No answer',
  failed: 'Failed',
  canceled: 'Canceled',
};

export function initCallButton(): void {
  // Handle phone button click - show modal with call history.
  // Both the row icon button (.phone-button) and the drawer "Call" pill
  // (.phone-composer-button) open the same call modal; they carry the same
  // data-* attributes.
  const callButtonSelector = '.phone-button[data-bots-prospect-id], .phone-composer-button[data-bots-prospect-id]';
  $(document).off('click', callButtonSelector);
  $(document).on('click', callButtonSelector, function(e) {
    e.preventDefault();
    e.stopPropagation();

    const $btn = $(this);
    const prospectId = $btn.data('prospect-id');
    const botsProspectId = $btn.data('bots-prospect-id');
    const prospectName = $btn.data('prospect-name');
    const phoneNumber = $btn.data('phone-number');

    if (!botsProspectId || !phoneNumber || !prospectId) {
      return; // No phone number, let default popover behavior happen
    }

    // Hide any open popovers
    $('[data-toggle="popover"]').popover('hide');

    // Show call modal with history
    showCallModalWithHistory(prospectId, botsProspectId, prospectName, phoneNumber);
  });

  // Handle modal close
  $(document).off('click', '.call-modal-close');
  $(document).on('click', '.call-modal-close', function() {
    closeCallModal();
  });

  $(document).off('click', '.call-modal-overlay');
  $(document).on('click', '.call-modal-overlay', function(e) {
    if (e.target === this) {
      closeCallModal();
    }
  });

  $(window).off('pagehide.callModal').on('pagehide.callModal', hangUpLiveCall);
  $(document).off('turbo:before-visit.callModal').on('turbo:before-visit.callModal', closeCallModal);

  $(document).off('keydown.callModal');
  $(document).on('keydown.callModal', function(e) {
    if (e.key === 'Escape' && $('#call-modal-container').length) {
      const modal = document.getElementById('call-modal');
      if (modal && closeOutcomeMenu(modal)) return;
      closeCallModal();
    }
  });

  // Handle Start Call button (also handles hangup for computer mode)
  $(document).off('click', '.start-call-btn');
  $(document).on('click', '.start-call-btn', function() {
    const $btn = $(this);
    const $modal = $('#call-modal');

    // If this is a hangup button for computer mode, hang up the call
    if ($btn.hasClass('hangup-btn') && !$btn.prop('disabled')) {
      hangupCall();
      return;
    }

    const botsProspectId = $modal.data('bots-prospect-id');
    const prospectName = $modal.data('prospect-name');
    const recordCall = $modal.find('.call-record-checkbox').is(':checked');

    startCall(botsProspectId, prospectName, recordCall);
  });

  // Handle mute button for computer mode
  $(document).off('click', '.mute-btn');
  $(document).on('click', '.mute-btn', function() {
    const $btn = $(this);
    const isMuted = isCallMuted();
    muteCall(!isMuted);

    if (!isMuted) {
      $btn.addClass('muted').html('<i class="fas fa-microphone-slash"></i>');
      $btn.attr('title', 'Unmute');
    } else {
      $btn.removeClass('muted').html('<i class="fas fa-microphone"></i>');
      $btn.attr('title', 'Mute');
    }
  });
}

function showCallModalWithHistory(prospectId: string, botsProspectId: string, prospectName: string, phoneNumber: string): void {
  // Remove existing modal if any
  $('#call-modal-container').remove();

  const initials = (prospectName || '').trim().split(/\s+/).map(w => w[0]).slice(0, 2).join('').toUpperCase() || '·';

  const params = [
    { key: 'prospectId', value: prospectId },
    { key: 'botsProspectId', value: botsProspectId },
    { key: 'prospectName', value: prospectName },
    { key: 'phoneNumber', value: phoneNumber },
    { key: 'initials', value: initials }
  ]

  const modalHtml = getHTMLElement(callModal, params);

  $('body').append(modalHtml);

  // Fetch call history
  $.ajax({
    url: `/calls/history/${botsProspectId}`,
    method: 'GET',
    success: function(calls) {
      const $list = $('.call-history-list');
      if (calls.length === 0) {
        $list.html('<div class="call-history-empty">No previous calls</div>');
      } else {
        const callsHtml = calls.map((call: any) => {
          const outcomeLabel = call.outcome ? (CALL_OUTCOME_LABELS[call.outcome] || call.outcome.replace(/_/g, ' ')) : '';
          const answered = call.status === 'completed';
          const statusLabel = answered ? 'Connected' : (CALL_STATUS_LABELS[call.status] || 'No answer');
          const title = `${statusLabel}${outcomeLabel ? ` · ${outcomeLabel}` : ''}`;
          const iconClass = answered ? 'connected' : 'missed';

          // The "▶ recording" link in the row meta toggles the (hidden) player below it.
          const recordingTrigger = call.recording_url ?
            `<button class="call-history-play-btn" data-recording-url="${call.recording_url}" data-call-id="${call.id}">
              <i class="fas fa-play"></i> recording
            </button>` : '';

          const params = [
            { key: "callId", value: call.id },
            { key: "callRecording", value: call.recording_url },
            { key: "recordingDuration", value: formatDuration(call.recording_duration) }
          ]

          const playerHtml = call.recording_url ?
                getHTMLString(recordingPlayer, params) : '';

          return `
            <div class="call-history-item">
              <div class="call-history-row">
                <span class="call-history-icon ${iconClass}">
                  <i class="fas fa-phone"></i>
                </span>
                <div class="call-history-info">
                  <div class="call-history-name">${title}</div>
                  <div class="call-history-date">${call.created_at}${call.campaign_name ? ` · in ${escapeHtml(call.campaign_name)}` : ''}</div>
                </div>
                <div class="call-history-meta">
                  <span class="call-history-duration">${formatDuration(call.recording_url ? call.recording_duration : 0)}</span>
                  ${recordingTrigger}
                </div>
              </div>
              ${playerHtml}
            </div>
          `;
        }).join('');
        const $items = $($.parseHTML(callsHtml) as HTMLElement[]).filter('.call-history-item').hide();
        $list.append($items);

        const recordingsLoaded = $items.find('audio').toArray().map(el => {
          const audio = el as HTMLAudioElement;
          setupAudioElement(audio);
          const loaded = waitForAudioMetadata(audio);
          audio.load();
          return loaded;
        });

        Promise.all(recordingsLoaded).then(() => {
          $list.find('.call-history-loading').remove();
          $items.show();
        });
      }
    },
    error: function() {
      $('.call-history-list').html('<div class="call-history-empty">Failed to load call history</div>');
    }
  });
}

function showCallInProgressModal(botsProspectId: string, prospectName: string, phoneNumber: string): void {
  const $modal = $('#call-modal');

  $modal.html(`
    <div class="call-modal-header">
      <span class="call-modal-status ready">Ready to call</span>
      <button class="call-modal-close">&times;</button>
    </div>
    <div class="call-modal-body">
      <div class="call-modal-name">${prospectName}</div>
      <div class="call-modal-phone">${phoneNumber}</div>
      <div class="call-modal-timer">00:00</div>
    </div>
    <div class="call-modal-footer">
      <button class="start-call-btn" disabled>
        <i class="fas fa-spinner fa-spin"></i>
        <span>Calling...</span>
      </button>
    </div>
  `);
}

type LiveCall = { callLogId: number | null, mode: string };

let liveCall: LiveCall | null = null;

function requestHangUp(callLogId: number): void {
  fetch(`/calls/${callLogId}/hang_up`, {
    method: 'PATCH',
    keepalive: true,
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || ''
    }
  }).catch(() => undefined);
}

function hangUpLiveCall(): void {
  const call = liveCall;
  liveCall = null;
  if (!call) return;

  if (call.mode === 'computer') hangupCall();
  if (call.callLogId) requestHangUp(call.callLogId);
}

function closeCallModal(): void {
  hangUpLiveCall();
  $('#call-modal-container').remove();
  if ((window as any).callPollInterval) {
    clearInterval((window as any).callPollInterval);
    (window as any).callPollInterval = null;
  }
  if ((window as any).callTimerInterval) {
    clearInterval((window as any).callTimerInterval);
    (window as any).callTimerInterval = null;
  }
  (window as any).callWasRecording = null;
}

function startCall(botsProspectId: string, prospectName: string, recordCall: boolean): void {
  const $modal = $('#call-modal');
  const phoneNumber = $modal.find('.call-modal-phone-number').text() || $modal.find('.call-modal-phone').text();
  const callMode = $modal.find('input[name="call-mode"]:checked').val() as string || 'phone';

  // Store recording preference for later
  (window as any).callWasRecording = recordCall;
  (window as any).currentCallMode = callMode;

  const params = [
    { key: "prospectName", value: prospectName },
    { key: "phoneNumber", value: phoneNumber },
  ]

  // Transform modal to call-in-progress view
  const inProgressHtml = callMode === 'computer'
    ? getHTMLElement(computerMode, params)
    : getHTMLElement(phoneMode, params);

  $modal.html(inProgressHtml);

  const $startBtn = $modal.find('.start-call-btn');
  const $status = $modal.find('.call-modal-status');
  const attempt: LiveCall = { callLogId: null, mode: callMode };
  liveCall = attempt;

  $.ajax({
    url: '/calls',
    method: 'POST',
    data: { bots_prospect_id: botsProspectId, record: recordCall, call_mode: callMode },
    success: function(response) {
      if (liveCall !== attempt) {
        if (callMode === 'phone' && response.call_log_id) requestHangUp(response.call_log_id);
        return;
      }
      attempt.callLogId = response.call_log_id || null;

      if (response.success) {
        if (callMode === 'computer') {
          startBrowserCall(response, $modal, attempt);
        } else {
          $status.text('Ringing...');
          $startBtn.html('<i class="fas fa-phone"></i> <span>Ringing...</span>');
          pollCallStatusModal(response.call_log_id);
        }
      } else {
        liveCall = null;
        $status.removeClass('calling').addClass('error').text('Failed');
        $startBtn.prop('disabled', false).html('<i class="fas fa-phone"></i> <span>Retry</span>');
      }
    },
    error: function(xhr) {
      if (liveCall !== attempt) return;
      liveCall = null;
      const response = xhr.responseJSON;
      $status.removeClass('calling').addClass('error').text(response?.error || 'Failed to call');
      $startBtn.prop('disabled', false).html('<i class="fas fa-phone"></i> <span>Retry</span>');
    }
  });
}

async function startBrowserCall(response: any, $modal: JQuery, attempt: LiveCall): Promise<void> {
  const $status = $modal.find('.call-modal-status');
  const $startBtn = $modal.find('.start-call-btn');
  const $timer = $modal.find('.call-modal-timer');

  try {
    $status.text('Connecting...');

    const call = await makeCall({
      To: response.prospect_phone,
      CallerId: response.caller_id,
      Record: response.record ? 'true' : 'false'
    });

    if (liveCall !== attempt) {
      hangupCall();
      return;
    }

    if (!call) {
      throw new Error('Failed to connect call');
    }

    (window as any).currentCallLogId = response.call_log_id;
    (window as any).activeBrowserCall = call;

    call.on('ringing', () => {
      $status.text('Ringing...');
      $startBtn.html('<i class="fas fa-phone-volume"></i> <span>Ringing...</span>');
    });

    call.on('accept', () => {
      $status.removeClass('calling').addClass('in-call').text('In call');
      $startBtn.html('<i class="fas fa-phone-slash"></i> <span>Hang Up</span>')
        .prop('disabled', false);

      // Update call log with actual Twilio SID
      const callSid = call.parameters?.CallSid;
      if (callSid) {
        $.ajax({
          url: `/calls/${response.call_log_id}/update_sid`,
          method: 'PATCH',
          data: { call_sid: callSid }
        });
      }

      // Start timer
      let timerSeconds = 0;
      (window as any).callTimerInterval = setInterval(() => {
        timerSeconds++;
        const mins = Math.floor(timerSeconds / 60).toString().padStart(2, '0');
        const secs = (timerSeconds % 60).toString().padStart(2, '0');
        $timer.text(`${mins}:${secs}`);
      }, 1000);
    });

    call.on('disconnect', () => {
      if (liveCall === attempt) liveCall = null;
      handleBrowserCallEnd($modal, response.call_log_id);
    });

    call.on('cancel', () => {
      if (liveCall === attempt) liveCall = null;
      handleBrowserCallEnd($modal, response.call_log_id);
    });

    call.on('error', (error: any) => {
      if (liveCall === attempt) liveCall = null;
      console.error('Call error:', error);
      $status.removeClass('calling').addClass('error').text('Call failed');
      $startBtn.prop('disabled', false).html('<i class="fas fa-phone"></i> <span>Retry</span>');
    });

  } catch (error) {
    if (liveCall === attempt) liveCall = null;
    console.error('Browser call failed:', error);
    $status.removeClass('calling').addClass('error').text('Failed to connect');
    $startBtn.prop('disabled', false).html('<i class="fas fa-phone"></i> <span>Retry</span>');
  }
}

function handleBrowserCallEnd($modal: JQuery, callLogId: number): void {
  if ((window as any).callTimerInterval) {
    clearInterval((window as any).callTimerInterval);
    (window as any).callTimerInterval = null;
  }
  (window as any).activeBrowserCall = null;

  // Show completion UI - poll for final status and recording
  pollCallStatusModal(callLogId);
}

function pollCallStatusModal(callLogId: number): void {
  const $modal = $('#call-modal');
  const $status = $modal.find('.call-modal-status');
  const $timer = $modal.find('.call-modal-timer');
  const $startBtn = $modal.find('.start-call-btn');

  let pollCount = 0;
  let completedCount = 0;
  let timerSeconds = 0;
  let timerStarted = false;
  const maxPolls = 300; // 5 minutes max
  const maxCompletedPolls = 10;
  let inFlight = false;
  let finished = false;

  (window as any).callPollInterval = setInterval(function() {
    if (inFlight || finished) return;
    pollCount++;

    if (pollCount > maxPolls || !$('#call-modal').length) {
      clearInterval((window as any).callPollInterval);
      if ((window as any).callTimerInterval) {
        clearInterval((window as any).callTimerInterval);
      }
      return;
    }

    inFlight = true;
    $.ajax({
      url: `/calls/${callLogId}/check`,
      method: 'GET',
      complete: function() {
        inFlight = false;
      },
      success: function(response) {
        if (finished || !$('#call-modal').length) return;
        if (['completed', 'busy', 'no_answer', 'failed', 'canceled'].includes(response.status)) finished = true;

        switch (response.status) {
          case 'initiated':
          case 'ringing':
            $status.text('Ringing...');
            $startBtn.html('<i class="fas fa-phone-volume"></i> <span>Ringing...</span>');
            break;
          case 'in_progress':
            $status.removeClass('calling').addClass('in-call').text('In call');
            $startBtn.html('<i class="fas fa-phone"></i> <span>In Call</span>');

            // Start timer if not started
            if (!timerStarted) {
              timerStarted = true;
              (window as any).callTimerInterval = setInterval(function() {
                timerSeconds++;
                $timer.text(formatDuration(timerSeconds));
              }, 1000);
            }
            break;
          case 'completed':
            liveCall = null;
            completedCount++;
            clearInterval((window as any).callTimerInterval);
            clearInterval((window as any).callPollInterval);

            // Use recording_duration (actual talk time) if available, otherwise fall back to duration
            const actualDuration = response.recording_duration || response.duration || timerSeconds;
            const wasRecording = (window as any).callWasRecording || false;

            // Show completion screen, poll for recording only if it was enabled
            showCallCompletionScreen($modal, callLogId, actualDuration, null, null, wasRecording);
            break;
          case 'busy':
          case 'no_answer':
          case 'failed':
          case 'canceled':
            liveCall = null;
            clearInterval((window as any).callPollInterval);
            if ((window as any).callTimerInterval) {
              clearInterval((window as any).callTimerInterval);
            }

            const statusText = response.status.replace('_', ' ');
            $status.removeClass('calling in-call').addClass('error').text(statusText.charAt(0).toUpperCase() + statusText.slice(1));
            $startBtn.html('<i class="fas fa-phone"></i> <span>Retry</span>').prop('disabled', false);
            break;
        }
      }
    });
  }, 1000);
}

function formatDuration(seconds: number | null | undefined): string {
  const value = Number(seconds);
  const secs = Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0;
  const mins = Math.floor(secs / 60);
  const remainingSecs = secs % 60;
  return `${mins.toString().padStart(2, '0')}:${remainingSecs.toString().padStart(2, '0')}`;
}

function showCallCompletionScreen($modal: JQuery, callLogId: number, duration: number, recordingUrl: string | null, recordingDuration: number | null, wasRecording: boolean = true): void {
  const recordingContent = recordingUrl
    ? callEndedPlayerHtml(recordingUrl, recordingDuration)
    : getHTMLString(recordingProcessing, [{ key: 'callLogId', value: String(callLogId) }]);

  const params = [
    { key: 'initials', value: $modal.attr('data-initials') || '' },
    { key: 'prospectName', value: $modal.attr('data-prospect-name') || '' },
    { key: 'phoneNumber', value: $modal.attr('data-phone-number') || '' },
    { key: 'duration', value: formatDuration(duration) },
    { key: 'callLogId', value: String(callLogId) },
    { key: 'recording', value: wasRecording ? getHTMLString(callEndedRecording, [{ key: 'content', value: recordingContent }]) : '' }
  ];

  $modal.addClass('is-ended').html(getHTMLString(callEnded, params));
  initCallEndScreen($modal[0]);

  // Set up audio element if recording is ready, or poll for it
  if (wasRecording) {
    if (recordingUrl) {
      initCallEndPlayer();
    } else {
      // Poll for recording if not ready yet
      pollForRecording(callLogId, $modal);
    }
  }
}

function pollForRecording(callLogId: number, $modal: JQuery): void {
  let attempts = 0;
  const maxAttempts = 60; // 60 seconds
  let inFlight = false;
  let found = false;

  const pollInterval = setInterval(function() {
    if (inFlight || found) return;
    attempts++;

    if (attempts > maxAttempts || !$('#call-modal').length) {
      clearInterval(pollInterval);
      $('.recording-processing').html(getHTMLString(recordingUnavailable, [{ key: 'callLogId', value: String(callLogId) }]));
      return;
    }

    inFlight = true;
    $.ajax({
      url: `/calls/${callLogId}/check`,
      method: 'GET',
      complete: function() {
        inFlight = false;
      },
      success: function(response) {
        if (found) return;
        if (response.recording_url && response.recording_duration > 0) {
          found = true;
          clearInterval(pollInterval);
          showRecordingPlayer(response.recording_url, response.recording_duration);
        } else if (response.recording_url) {
          // Test if the recording is actually ready by trying to load it
          const testAudio = new Audio();
          testAudio.preload = 'metadata';

          testAudio.onloadedmetadata = function() {
            if (found) return;
            found = true;
            clearInterval(pollInterval);
            showRecordingPlayer(response.recording_url, testAudio.duration);
          };

          testAudio.onerror = function() {
            // Recording URL exists but file not ready yet, keep polling
            console.log('Recording not ready yet, continuing to poll...');
          };

          testAudio.src = response.recording_url;
        }
      }
    });
  }, 2000); // Poll every 2 seconds
}

function callEndedPlayerHtml(recordingUrl: string, recordingDuration: number | null): string {
  return getHTMLString(callEndedPlayer, [
    { key: 'recordingUrl', value: recordingUrl },
    { key: 'recordingDuration', value: formatDuration(recordingDuration) }
  ]);
}

function showRecordingPlayer(recordingUrl: string, recordingDuration: number): void {
  const playerHtml = callEndedPlayerHtml(recordingUrl, recordingDuration);

  $('.recording-processing').replaceWith(playerHtml);
  initCallEndPlayer();
}

function initCallEndPlayer(): void {
  const audio = document.getElementById('call-recording-audio') as HTMLAudioElement;
  if (!audio) return;

  setupAudioElement(audio);
  audio.load();

  const wave = audio.closest('.call-end-player')?.querySelector<HTMLElement>('.call-end-wave');
  if (wave) {
    drawWaveform(wave, seconds => {
      $(wave).closest('.call-end-player').find('.audio-duration').text(formatDuration(seconds));
      $('.call-end-duration-value').text(formatDuration(seconds));
    });
  }
}

// Retry button handler
$(document).off('click', '.retry-recording-btn');
$(document).on('click', '.retry-recording-btn', function() {
  const callLogId = $(this).data('call-log-id');
  $('.recording-processing').html('<i class="fas fa-spinner fa-spin"></i> Recording processing...');
  pollForRecording(callLogId, $('#call-modal'));
});

// Handle Complete Call button
$(document).off('click', '.complete-call-btn');
$(document).on('click', '.complete-call-btn', function() {
  const $btn = $(this);
  const callLogId = $btn.data('call-log-id');
  const $modal = $('#call-modal');
  const outcome = $modal.find('.call-status-select').val();
  const botsProspectId = $modal.data('bots-prospect-id');
  const $label = $btn.find('.complete-call-label');

  if (!outcome) return;

  $btn.prop('disabled', true);
  $label.text('Saving…');

  $.ajax({
    url: `/calls/${callLogId}/outcome`,
    method: 'PATCH',
    data: { outcome: outcome },
    success: function(response) {
      // Update the status_calling dropdown in the Phone Dashboard
      if (response.status_calling && botsProspectId) {
        const $statusSelect = $(`.status_calling[data-bots-prospect-id="${botsProspectId}"]`);
        if ($statusSelect.length) {
          $statusSelect.val(response.status_calling);
          $statusSelect.removeClass().addClass(`form-control status_calling ${response.status_calling}`);
        }
        // refreshGridData();
        setStatusCallingOverride(String(botsProspectId), String(response.status_calling));
      }
      if (botsProspectId) announceFollowUps(String(botsProspectId), response.follow_ups);
      closeCallModal();
    },
    error: function() {
      $btn.prop('disabled', false);
      $label.text('Couldn’t save · try again');
    }
  });
});

// Handle play recording button in call history - show inline player
$(document).off('click', '.call-history-play-btn');
$(document).on('click', '.call-history-play-btn', function() {
  const callId = $(this).data('call-id');
  $(this).hide();
  $(`#player-${callId}`).show();

  // Set up audio element for duration detection
  const audio = document.getElementById(`audio-${callId}`) as HTMLAudioElement;
  if (audio) {
    setupAudioElement(audio);
    // Trigger load to get metadata
    audio.load();
  }
});

// Generic audio controls that work with any audio element via data-audio-id
$(document).off('click', '.audio-btn.audio-play-btn');
$(document).on('click', '.audio-btn.audio-play-btn', function() {
  const audioId = $(this).data('audio-id') || 'call-recording-audio';
  const audio = document.getElementById(audioId) as HTMLAudioElement;
  if (audio) {
    audio.play();
    $(this).hide();
    $(this).siblings('.audio-pause-btn').show();
  }
});

$(document).off('click', '.audio-btn.audio-pause-btn');
$(document).on('click', '.audio-btn.audio-pause-btn', function() {
  const audioId = $(this).data('audio-id') || 'call-recording-audio';
  const audio = document.getElementById(audioId) as HTMLAudioElement;
  if (audio) {
    audio.pause();
    $(this).hide();
    $(this).siblings('.audio-play-btn').show();
  }
});

$(document).off('click', '.audio-btn.audio-stop-btn');
$(document).on('click', '.audio-btn.audio-stop-btn', function() {
  const audioId = $(this).data('audio-id') || 'call-recording-audio';
  const audio = document.getElementById(audioId) as HTMLAudioElement;
  if (audio) {
    audio.pause();
    audio.currentTime = 0;
    const $container = $(this).closest('.call-history-player, .call-recording-player');
    $container.find('.audio-pause-btn').hide();
    $container.find('.audio-play-btn').show();
    $container.find('.audio-progress-bar').css('width', '0%');
    $container.find('.audio-current').text('00:00');
    const wave = $container.find('.call-end-wave')[0];
    if (wave) paintWaveform(wave, 0);
  }
});

function waitForAudioMetadata(audio: HTMLAudioElement, timeoutMs: number = 15000): Promise<void> {
  return new Promise(resolve => {
    const timer = window.setTimeout(done, timeoutMs);
    function done(): void {
      window.clearTimeout(timer);
      audio.removeEventListener('loadedmetadata', done);
      audio.removeEventListener('error', done);
      resolve();
    }
    audio.addEventListener('loadedmetadata', done);
    audio.addEventListener('error', done);
  });
}

// Set up audio element with all event listeners
function setupAudioElement(audioElement: HTMLAudioElement): void {
  const $container = $(audioElement).closest('.call-history-player, .call-recording-player');

  let resolvingLength = false;

  const showLength = (): void => {
    if (!audioElement.duration || !Number.isFinite(audioElement.duration)) return;

    const durationSecs = Math.floor(audioElement.duration);
    $container.find('.audio-duration').text(formatDuration(durationSecs));

    // Also update the main duration display in completion screen
    $('.call-end-duration-value').text(formatDuration(durationSecs));

    // And in call history
    $container.closest('.call-history-item').find('.call-history-duration').text(formatDuration(durationSecs));
  };

  // A recording streamed without a known length reports Infinity until the browser has read to its end.
  audioElement.addEventListener('loadedmetadata', function() {
    if (audioElement.duration === Infinity) {
      resolvingLength = true;
      audioElement.currentTime = 1e7;
    }
    showLength();
  });

  audioElement.addEventListener('durationchange', function() {
    if (!Number.isFinite(audioElement.duration)) return;

    showLength();
    if (resolvingLength) {
      resolvingLength = false;
      audioElement.currentTime = 0;
    }
  });

  audioElement.addEventListener('timeupdate', function() {
    if (resolvingLength) return;
    const wave = $container.find('.call-end-wave')[0];
    if (wave && Number.isFinite(audioElement.duration) && audioElement.duration > 0) {
      paintWaveform(wave, audioElement.currentTime / audioElement.duration);
    }
    if (Number.isFinite(audioElement.duration) && audioElement.duration > 0) {
      const percent = (audioElement.currentTime / audioElement.duration) * 100;
      $container.find('.audio-progress-bar').css('width', percent + '%');
    }
    $container.find('.audio-current').text(formatDuration(Math.floor(audioElement.currentTime)));
  });

  audioElement.addEventListener('ended', function() {
    const wave = $container.find('.call-end-wave')[0];
    if (wave) paintWaveform(wave, 0);
    $container.find('.audio-pause-btn').hide();
    $container.find('.audio-play-btn').show();
    $container.find('.audio-progress-bar').css('width', '0%');
    $container.find('.audio-current').text('00:00');
  });
}

// Click on progress bar to seek
$(document).off('click', '.audio-progress');
$(document).on('click', '.audio-progress', function(e) {
  const audioId = $(this).data('audio-id') || 'call-recording-audio';
  const audio = document.getElementById(audioId) as HTMLAudioElement;
  if (audio && audio.duration && Number.isFinite(audio.duration)) {
    const rect = (this as HTMLElement).getBoundingClientRect();
    const percent = (e.clientX - rect.left) / rect.width;
    audio.currentTime = percent * audio.duration;
  }
});

export function initWriteWithAIButton(): void {
  $(document).off('click', '.write-with-ai-button');

  $(document).on('click', '.write-with-ai-button', function () {
    const botId = $(this).data('bot-id')
    const prospectId = $(this).data('bots-prospect-id')
    const button = this

    button.disabled = true
    button.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Generating...'

    $.ajax({
      url: `/bots/${botId}/prospects/${prospectId}/write_with_ai`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: function (data) {
        const form = button.closest('form')
        if (!form) return

        const messageTextarea = form.querySelector('textarea[name="bots_prospect_unipile_request[invitation_note]"]');
        if (messageTextarea) {
          (messageTextarea as HTMLTextAreaElement).value = data.message

          updateCharacterCount(messageTextarea)
          $('.send-with-note-button').prop('disabled', false)
        }
      },
      error: function (xhr: any) {
        let errorMessage = 'Failed to generate AI message. Please try again.'
        if (xhr.responseJSON && xhr.responseJSON.error) {
          errorMessage = 'Error generating AI message: ' + xhr.responseJSON.error
        }
        alert(errorMessage)
      },
      complete: function () {
        button.disabled = false
        button.innerHTML = '<i class="fas fa-robot"></i> Write with AI'
      }
    })
  })
}

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function formatTime(timestamp) {
  const date = new Date(timestamp);
  let shortFormat = date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
  shortFormat = shortFormat.replace(',', ' at');
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  const fullFormat = `${year}-${month}-${day} ${hour}:${minute}`;

  return { shortFormat, fullFormat };
}

function appendNewMessage(msg, prospectName = "You"){
  const container = $('#messages-container')
  const messageId = "message-" + msg.message_id;

  const $message = container.children(`#${messageId}`);
  if ($message.length) {
    const rawText = msg.text || "";
    let textHtml = escapeHtml(rawText).replace(/\n/g, '<br>');
    if (msg.event == "message_received" || msg.event == "message_delivered"){
      const time = formatTime(msg.sent_at)
      const newTime =  time.shortFormat
      const titleMessage = "Sent at " + time.fullFormat
      if (updateUIMessageBoxBefore(msg.is_sender, titleMessage, messageId)){
        $message.find(".message-author").addClass("d-none")
        $message.find(".message-text").addClass(msg.is_sender ? "message-box-top-right" : "message-box-top-left")
        $message.find(".message-time").text(newTime)
      }
      $message.find(".message-text").html(textHtml).attr("title", titleMessage)
    } else if (msg.event == "message_deleted"){
      $message.find(".message-text").html("This message has been deleted.").addClass("message-deleted")
    } else if (msg.event == "message_edited"){
      textHtml += '<small class="pl-1" style="opacity: .7;">(Edited)</small>'
      $message.find(".message-text").html(textHtml)
    }
  } else {
    if (msg.event == "message_edited" || msg.event == "message_deleted") return
    const html = renderMessage(msg, prospectName)
    container.append(html);
    container[0].scrollTo({
      top: container[0].scrollHeight,
      behavior: "smooth"
    });
  }
}

function updateUIMessageBoxBefore(isSender, titleMessage, messageId = null){
  let groupMessage = false
  const $container = $('#messages-container')
  let $messageBoxLast = $container.children().last()
  if (messageId) {
    $messageBoxLast = $messageBoxLast.attr("id") === messageId ? $container.children().eq(-2) : null;
    if (!$messageBoxLast) return false;
  }
  const isEndAndSender = $messageBoxLast.hasClass("align-items-end") && isSender;
  const isStartAndNotSender = $messageBoxLast.hasClass("align-items-start") && !isSender;
  if ( isEndAndSender || isStartAndNotSender ){
    const $messageTextLast = $messageBoxLast.find(".message-text").first();
    if ($messageTextLast.attr("title") && $messageTextLast.attr("title") == titleMessage){
      groupMessage = true
      $messageBoxLast.find(".message-time").first().addClass("d-none")
      $messageTextLast.addClass(isEndAndSender ? "override-bottom-right" : "override-bottom-left")
    }
  }
  return groupMessage
}

function renderMessage(msg, prospectName){
  const messageId = "message-" + msg.message_id;
  const isSender = msg.is_sender;
  const edited = msg.edited;
  const deleted = msg.deleted;
  const rawText = msg.text || "";
  let textHtml = escapeHtml(rawText).replace(/\n/g, '<br>');
  if (deleted){
    textHtml = "This message has been deleted."
  } else if (edited) {
    textHtml += '<small class="pl-1" style="opacity: .7;">(Edited)</small>'
  }
  let timeShortFormat = "Sent ✓", titleMessage = ""
  if (msg.sent_at){
    const time  = formatTime(msg.sent_at)
    timeShortFormat= time.shortFormat
    titleMessage = "Sent at " + time.fullFormat
  }
  const groupMessage = updateUIMessageBoxBefore(isSender, titleMessage)
  const boxCornerClass = isSender
  ? (groupMessage ? "message-box-top-right" : "message-box-bottom-right")
  : (groupMessage ? "message-box-top-left" : "message-box-bottom-left")

  return `
    <div id="${messageId}" class="mb-1 d-flex flex-column ${isSender ? "align-items-end" :"align-items-start"}" data-messages-target="message">
      <div class="${isSender ? "message-author mr-2" : "ml-2"} mb-1  ${groupMessage ? "d-none" : ""}">
        <small class="text-dark" style="font-weight: 600;">${isSender ? "You" : prospectName}</small>
      </div>
      <div class="${isSender ? "bg-primary text-white" : "bg-white border"} p-3 message-text ${deleted? "message-deleted": ""} ${boxCornerClass}" title="${titleMessage}">
        ${textHtml}
      </div>
      <small class="text-muted message-time mt-1">${timeShortFormat}</small>
    </div>`;
}

export function initShowAllSkillsButton(){
  $(document).on('click', '.show-all-skills-btn', function () {
    const $ele = $(this)
    const $parent = $ele.closest('.info-group-items')
    $parent.find('.hidden-tag').removeClass('hidden-tag')
    $ele.addClass('d-none')
  })

  $(document).on('click', '.show-all-exp-btn', function () {
    const $ele = $(this)
    const $parent = $ele.closest('.info-group-items')
    $parent.find('.hidden-exp').removeClass('hidden-exp')
    $ele.addClass('d-none')
  })
}

export function initShowProspectDetailBtn() {
  $(document).off('click', '.show-prospect-detail-btn, .show-more-info-tab');
  $(document).on('click', '.show-prospect-detail-btn, .show-more-info-tab', function (event) {
    event.preventDefault();
    const $clickedBtn = $(this)
    const $containerEle = $clickedBtn.hasClass('show-more-info-tab') ? $('.prospect-info-content') : $('.prospect-detail-container');
    const url = $clickedBtn.data('url');
    const spinner = '<div class="d-flex justify-content-center" style="height: 100%;"><div class="spinner-border text-primary m-5" role="status"></div></div>'
    $containerEle.html(spinner)
    $('.show-more-info-tab').addClass('active');
    $('.show-prospect-ai-review-tab').removeClass('active');

    $.ajax({
      url: url,
      success: function(res) {
        $containerEle.html(res);
        $clickedBtn.addClass('data-fetched')

        if($containerEle.hasClass('prospect-detail-container')) {
          $('.show-prospect-ai-review-tab').get(0).click();
        }
      },
    });

    $(".qlfr-modal-container.prospect-aim-modal").addClass('active')
    syncPageScrollLock(); // lock now, not on the observer's next frame
  });
}

export function initShowProspectAiReviewBtn() {
  $(document).off(
    "click",
    ".show-prospect-ai-review-tab, .rerun-ai-review-btn",
  );
  $(document).on(
    "click",
    ".show-prospect-ai-review-tab, .rerun-ai-review-btn",
    function (event) {
      event.preventDefault();

      if (
        !$(this).hasClass("rerun-ai-review-btn") ||
        confirm("Are you sure you want to re-run AI review for this candidate?")
      ) {
        const url = $(this).data("url");
        const botProspectId = $(this).data("bot-prospect-id");
        const spinner =
          '<div class="d-flex justify-content-center" style="height: 100%;"><div class="spinner-border text-primary m-5" role="status"></div></div>';
        $(".prospect-info-content").html(spinner);
        $(".show-more-info-tab").removeClass("active");
        $(".show-prospect-ai-review-tab").addClass("active");

        $.ajax({
          url: url,
          success: function (res) {
            $(".prospect-info-content").html(res.partial);
            $(`.ai-review-badge-${botProspectId}`).html(res.ai_review_badge);
          },
        });
      }
    },
  );
}

export function initMarkAsPassedBtn() {
  $(document).off('click', '.mark-passed-btn');
  $(document).on('click', '.mark-passed-btn', function (event) {
    event.preventDefault();

    if (confirm('Are you sure you want to mark this prospect as passed?')) {
      const url = $(this).data('url');
      const botProspectId = $(this).data('bot-prospect-id');
      const spinner = '<div class="d-flex justify-content-center" style="height: 100%;"><div class="spinner-border text-primary m-5" role="status"></div></div>'
      $('.prospect-info-content').html(spinner)
      $('.show-more-info-tab').removeClass('active');
      $('.show-prospect-ai-review-tab').addClass('active');

      $.ajax({
        method: 'PUT',
        url: url,
        success: function(res) {
          $('.prospect-info-content').html(res.partial);
          $(`.ai-review-badge-${botProspectId}`).html(res.ai_review_badge)
          $(`.email-button-${botProspectId}`).replaceWith(res.email_btn);
          $(`.phone-button-${botProspectId}`).replaceWith(res.phone_btn);
          $('[data-toggle="popover"]').popover();
          initCallButton();
        },
      });
    }
  });
}

export function initRequestAdditionalProspectsButton(): void {
  let $pendingRequestForm: JQuery | null = null;

  $(document).on(
    "click",
    ".add-prospects-btn",
    function (e) {
      const $btn = $(this);
      if ($btn.is("[disabled]") || $btn.hasClass("disabled")) return;
      const $form = $btn.closest(".request-additional-prospects-form");
      if (!$form.length) return;
      e.preventDefault();
      $pendingRequestForm = $form;
      const $modal = $("#requestAdditionalProspectsModal");
      $modal
        .find(".company-name-placeholder")
        .text($form.data("company-name") || "");
      $modal.find(".additional-info-textarea").val("");
      $modal.modal("show");
    },
  );

  $(document).on(
    "hidden.bs.modal",
    "#requestAdditionalProspectsModal",
    function () {
      $pendingRequestForm = null;
      $(this).find(".additional-info-textarea").val("");
    },
  );

  $(document).on(
    "click",
    "#requestAdditionalProspectsModal .send-request-additional-prospects-button",
    function () {
      if (!$pendingRequestForm) return;
      const $modal = $("#requestAdditionalProspectsModal");
      const additionalInfo =
        ($modal.find(".additional-info-textarea").val() as string) || "";
      const $form = $pendingRequestForm;
      $form.find('input[name="additional_info"]').remove();
      $("<input>")
        .attr({ type: "hidden", name: "additional_info" })
        .val(additionalInfo)
        .appendTo($form);
      $pendingRequestForm = null;
      $modal.modal("hide");
      const formEl = $form[0] as HTMLFormElement;
      if (typeof formEl.requestSubmit === "function") {
        formEl.requestSubmit();
      } else {
        formEl.dispatchEvent(
          new Event("submit", { bubbles: true, cancelable: true }),
        );
      }
    },
  );

  $(document).on(
    "ajax:send",
    ".request-additional-prospects-form",
    function () {
      const $addProspectsBtn = $(this).find(".add-prospects-btn");
      $addProspectsBtn.prop("disabled", true);
      $addProspectsBtn.text("Requesting...");
    },
  );

  $(document).on(
    "ajax:success",
    ".request-additional-prospects-form",
    function () {
      const $addProspectsBtn = $(this).find(".add-prospects-btn");
      $addProspectsBtn.prop("disabled", true);
      $addProspectsBtn.addClass("disabled");
      $addProspectsBtn.text("Requested");
      $addProspectsBtn.attr("title", "Requested");
      const companyName = $(this).data("company-name");
      showNotice(
        `Additional prospects for ${companyName} have been requested.`,
        "success",
      );
    },
  );

  $(document).on(
    "ajax:error",
    ".request-additional-prospects-form",
    function (event) {
      const response = event.detail?.[0] || {};
      const $addProspectsBtn = $(this).find(".add-prospects-btn");
      $addProspectsBtn.prop("disabled", false);
      $addProspectsBtn.text("Request Additional Prospects");
      const errorMessage =
        response?.error ||
        "Failed to request additional prospects. Please try again.";
      showNotice(errorMessage, "error");
    },
  );
}